import React, { useState, useEffect } from 'react';

const FRAMES = [6, 1, 2, 3, 4, 5].map((n) => `/assets/headset/${n}.webp`);
const FRAME_MS = 2500;

const MetaverseBackground = () => {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setFrame((n) => (n + 1) % FRAMES.length),
      FRAME_MS
    );
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: -1000,
        animation: 'fadeIn 2.5s ease-out both'
      }}
    >
      {FRAMES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          style={{
            position: 'absolute',
            inset: 0,
            width: '100vw',
            height: '100dvh',
            objectFit: 'cover',
            display: 'block',
            zIndex: i === frame ? 1 : 0,
            opacity: i === frame ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            willChange: 'opacity',
            transform: 'translateZ(0)',
            backfaceVisibility: 'hidden'
          }}
        />
      ))}
    </div>
  );
};

export default MetaverseBackground;
